export default "__VITE_ASSET__CVLzPRSl__"